
import { mapState } from 'vuex'

import AccountInfo from '@/components/account/AccountInfoSection.vue'
import AccountOffers from '@pleinair/bigcolony-vue/components/account/default/sections/AccountOffers.vue'
import AccountHistory from '@pleinair/bigcolony-vue/components/account/default/sections/AccountHistory.vue'
import AccountPayments from '@pleinair/bigcolony-vue/components/account/default/sections/AccountPayments.vue'
import AccountLocations from '@pleinair/bigcolony-vue/components/account/default/sections/AccountLocations.vue'
import AccountRewardsSingle from '@pleinair/bigcolony-vue/components/account/default/sections/AccountRewardsSingle.vue'
import AccountRewardsSection from '@pleinair/bigcolony-vue/components/account/default/sections/AccountRewardsSection/index.vue'

export default {
  name: 'AccountBody',
  components: {
    AccountInfo,
    AccountHistory,
    AccountPayments,
    AccountOffers,
    AccountRewardsSingle,
    AccountRewardsSection,
    AccountLocations,
  },
  props: {
    menu: Array,
    fields: Object,
  },
  computed: {
    ...mapState([ 'token', 'user', 'activeAccountSection' ])
  },
  async beforeMount() {
    if(!this.token) {
      this.$router.push('/account/signin')
    }
  }
}
